import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService, LaunchDarklyUserGuard } from 'remarketing-angular-library';

/**
 * Guard that matches when the React auction-summary remote flag is ENABLED.
 * Used for the remote-buyers auction-summary route.
 * If this guard returns false, the legacy Angular route (without this guard) is the fallback.
 *
 * canMatch, not canActivate: LaunchDarklyUserGuard.canActivate redirects the browser when a
 * flag is off rather than resolving false, and canActivate does not fall through to the next
 * route entry at the same path regardless. Only canMatch gives flag-off rollback with no deploy.
 *
 * Mirrors bidlistReactGuard exactly (see src/vehicles/guards/bidlist-react-version.guard.ts).
 * The flag is `buy-auctionSummary-enableReact` — distinct from the existing `auctionSummaryEnabled`
 * route-data flag, which stays on the Angular fallback entry as the route-activation gate.
 */
export const auctionSummaryReactGuard: CanMatchFn = () => {
  const authService = AuthService.getInstance();

  if (!authService.isAuthenticated()) {
    return true;
  }

  return inject(LaunchDarklyUserGuard).canMatch('buy-auctionSummary-enableReact');
};
